import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createCitiesSlice = (set, get) => ({
    cities: {
        loading: false,
        data: [],
    },
    getCities: async (param) => {
       
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ cities: { ...state.cities, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: 'get',
                baseURL: config.apiUrls(),
                url: `/v1/business/province/${param}/city`,
                headers: { token }
            });
            set(state => ({ cities: { loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ cities: { ...state.cities, loading: false } }));
        }
    }
});

